import React, { useState, useEffect } from 'react';
import { EmpresaApi } from '../../api/EmpresaApi';
import './Empresas.css';

const Empresas = () => {
  const [empresas, setEmpresas] = useState([]);
  const [expandedCardId, setExpandedCardId] = useState(null);

  const empresaApi = new EmpresaApi();

  useEffect(() => {
    const fetchEmpresas = async () => {
      try {
        const data = await empresaApi.getAllEmpresas();
        setEmpresas(data);
      } catch (error) {
        console.error('Error fetching companies:', error);
      }
    };
    fetchEmpresas();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toggleExpand = (id) => {
    setExpandedCardId((prevId) => (prevId === id ? null : id)); // Solo una tarjeta expandida a la vez
  };

  return (
    <div className="empresas-container">
      {empresas.map((empresa) => (
        <div
          key={empresa.id}
          className={`empresa-card ${expandedCardId === empresa.id ? 'expanded' : ''}`}
          onClick={() => toggleExpand(empresa.id)}
        >
          <div className="empresa-info-basica">
            <h2>{empresa.nombre}</h2>
            <p>Vacantes: {empresa.vacantes}</p>
            <p>Comisión: {empresa.comision}%</p>
            {/* Flechita que indica si la tarjeta está expandida */}
            <span className={`arrow ${expandedCardId === empresa.id ? 'up' : 'down'}`}></span>
          </div>

          <div className={`empresa-info-detallada ${expandedCardId === empresa.id ? 'show' : ''}`}>
          <hr className="divider" />
            <p>Descripción: {empresa.descripcion}</p>
            <p>Duración: {empresa.duracion} meses</p>
            <p>Mandar video presentación a: <b>ceocloseracademy@gmail.com</b></p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Empresas;
